<template>
  <AnimationComponent>
    <SectionWithCarousel
      :tag="tag"
      :title="title"
      :titleImage="titleImage"
      :titlePrefix="titlePrefix"
      :titleIcon="titleIcon"
      :titleSuffix="titleSuffix"
      :description="description"
      :items="features"
      :add-padding-x="addPaddingX"
      :use-alternative-tag-text-color="useAlternativeTagTextColor"
    >
      <template #card="{ item }">
        <FeatureCard
          :icon="item.image || (item.icon ? getIconComponent(item.icon) : '')"
          :title="item.title"
          :description="item.description"
          :hasButton="hasButton && !!item.buttonLabel"
          :buttonLabel="item.buttonLabel"
          :buttonStyle="item.buttonStyle"
          :buttonLink="item.buttonLink"
          :buttonFontColor="item.buttonFontColor"
          :style="cardStyle"
          class="basis-full shrink-0 grow-0"
        />
      </template>
    </SectionWithCarousel>
  </AnimationComponent>
</template>

<script setup lang="ts">
import { getIconComponent } from '@/utils/icons';
import { computed } from 'vue';
import AnimationComponent from '../AnimationComponent.vue';
import FeatureCard from './FeatureCard.vue';
import SectionWithCarousel from './SectionWithCarousel.vue';
import { useMediaQuery } from '@vueuse/core';

const isDesktop = useMediaQuery('(min-width: 1024px)');

export interface Feature {
  icon?: string;
  image?: string;
  title: string;
  description: string;
  buttonLabel?: string;
  buttonStyle?: 'outline-light' | 'default' | 'destructive' | 'outline' | 'ghost' | 'link' | 'greyed' | 'secondary';
  buttonLink?: string;
  buttonFontColor?: string;
}

interface Props {
  tag?: string;
  title?: string;
  titleImage?: string;
  titlePrefix?: string;
  titleIcon?: string;
  titleSuffix?: string;
  description?: string;
  features: Feature[];
  hasButton?: boolean;
  itemsPerRow?: number;
  addPaddingX?: boolean;
  useAlternativeTagTextColor?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  tag: '',
  title: '',
  titleImage: '',
  description: '',
  itemsPerRow: 3,
  addPaddingX: true,
  useAlternativeTagTextColor: false,
});

const cardStyle = computed(() => {
  const percentage = (100 / props.itemsPerRow).toFixed(3);
  return {
    flexBasis: `calc(${percentage}% - 2rem)`,
    flexGrow: props.features.length === 3 && isDesktop.value ? 1 : 0,
  };
});
</script>
